<template>
  <MapModal
    :modalNode="modalNode"
    :title="title"
    id="scenerModel"
    :close="scenerModelClose"
    ref="scenerModel"
  >
    <template slot="content">
      <div class="content">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="项目标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="显示弹窗">
            <el-switch v-model="form.isShow"></el-switch>
          </el-form-item>
          <el-form-item label="弹窗内容">
            <Editor v-model="form.richText" :toolbar="toolbar"></Editor>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template slot="foot">
      <div class="foot-operate">
        <el-button @click="scenerModelClose"> 取消 </el-button>
        <el-button type="primary" @click="onSubmit('form')"> 保存 </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
import {
  getProjectSettings,
  postProjectSettingsedit,
  postBimPlanEdit,
  getBimPlanDetail,
} from "@/api/api";
const MapModal = () => import("@/components/common/mapModal/Index");
const Editor = () => import("@/components/common/imcoderTinymce/Index");
export default {
  name: "changeTitleDialog",
  components: { MapModal, Editor },
  props: [],
  data() {
    return {
      title: "初始信息",
      modalNode: {
        planDemo: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 7,
            y: -70,
            // left: 22,
            // top:20
            unit: "%", // 默认px
          },
          width: "40%", // 宽度配置 默认450px
          height: "85%", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      form: {},
      rules: {
        title: [{ required: true, message: "请输入项目标题", trigger: "blur" }],
      },
      toolbar:
        "undo redo | styleselect | bold italic forecolor | lists image table",
      projectId: window.sessionStorage.getItem("nowProjectId"),
    };
  },
  methods: {
    scenerModelClose() {
      this.$emit("closeChangeTitleDialog");
    },
    // 保存提交
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          postBimPlanEdit(this.form).then((res) => {
            if (res.status === 200) {
              this.$notify({
                title: "您已成功保存此设置",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            }
          });
          this.scenerModelClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  mounted() {
    const params = {
      Id: this.projectId,
    };
    // getProjectSettings(params).then((res) => {
    //   this.form = res.data.data;
    // });
    getBimPlanDetail({
      Id: this.$route.params.scenarioGroupId,
    }).then((res) => {
      this.form = res.data.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.content {
  width: 100%;
  height: 100%;
  padding: 60px 60px;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
</style>
